module.exports = __webpack_public_path__ + "img/box-wrap.ccd8a3d0.svg";